import React from 'react';
import { FaPhone, FaEnvelope, FaWhatsapp, FaMapMarkerAlt, FaClock, FaHeadset } from 'react-icons/fa';

const Support : React.FC = () => {
  // Company contact information
  const contactInfo = {
    phone: '+91 7978949923',
    whatsapp: '+917978949923',
    email: 'admin@udyamwell.in',
    address: 'Catalyst Building, IIT Mandi, Himachal Pradesh - 175005, India',
    workingHours: 'Monday to Saturday: 9:00 AM to 6:00 PM',
    supportHours: 'Customer Support: 24/7'
  };

  // WhatsApp link generator
  const whatsappLink = `https://wa.me/${contactInfo.whatsapp.replace('+', '')}?text=Hello%20I%20have%20a%20question%20about...`;

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">Contact Us</h1>
        <p className="mt-4 text-lg text-gray-600">
          We're here to help. Choose your preferred way to reach out to our team.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        {/* Phone Support */}
        <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-blue-100 p-3 rounded-full mr-4">
              <FaPhone className="text-blue-600 text-xl" />
            </div>
            <h2 className="text-xl font-semibold text-gray-800">Phone Support</h2>
          </div>
          <p className="text-gray-600 mb-4">Speak directly with our support team</p>
          <a 
            href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
            className="text-blue-600 hover:text-blue-800 font-medium text-lg flex items-center"
          >
            <FaPhone className="mr-2" /> {contactInfo.phone}
          </a>
          <p className="text-sm text-gray-500 mt-2">{contactInfo.supportHours}</p>
        </div>

        {/* Email Support */}
        <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <FaEnvelope className="text-green-600 text-xl" />
            </div>
            <h2 className="text-xl font-semibold text-gray-800">Email Us</h2>
          </div>
          <p className="text-gray-600 mb-4">Send us an email and we'll get back to you</p>
          <a 
            href={`mailto:${contactInfo.email}`}
            className="text-blue-600 hover:text-blue-800 font-medium text-lg flex items-center"
          >
            <FaEnvelope className="mr-2" /> {contactInfo.email}
          </a>
          <p className="text-sm text-gray-500 mt-2">Typically respond within 24 hours</p>
        </div>

        {/* WhatsApp */}
        <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <FaWhatsapp className="text-green-600 text-xl" />
            </div>
            <h2 className="text-xl font-semibold text-gray-800">WhatsApp</h2>
          </div>
          <p className="text-gray-600 mb-4">Chat with us on WhatsApp</p>
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-lg flex items-center justify-center w-full transition-colors duration-300"
          >
            <FaWhatsapp className="mr-2 text-xl" /> Start Chat
          </a>
          <p className="text-sm text-gray-500 mt-2">Available during business hours</p>
        </div>
      </div>

      {/* Address and Working Hours */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Office Address */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="flex items-center mb-4">
            <div className="bg-purple-100 p-3 rounded-full mr-4">
              <FaMapMarkerAlt className="text-purple-600 text-xl" />
            </div>
            <h2 className="text-xl font-semibold text-gray-800">Our Office</h2>
          </div>
          <address className="text-gray-600 not-italic">
            <p className="mb-2">{contactInfo.address}</p>
            {/* <a 
              href=`https://maps.google.com/?q=' + ${contactInfo.address}}`
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 inline-block mt-2"
            >
              View on Google Maps
            </a> */}
          </address>
        </div>

        {/* Working Hours */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="flex items-center mb-4">
            <div className="bg-orange-100 p-3 rounded-full mr-4">
              <FaClock className="text-orange-600 text-xl" />
            </div>
            <h2 className="text-xl font-semibold text-gray-800">Working Hours</h2>
          </div>
          <div className="text-gray-600">
            <p className="mb-2">{contactInfo.workingHours}</p>
            <p className="flex items-center">
              <FaHeadset className="mr-2 text-blue-500" /> {contactInfo.supportHours}
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form (optional) */}
      {/* <div className="mt-12 bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Send Us a Message</h2>
        <form className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                Your Name
              </label>
              <input
                type="text"
                id="name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your name"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your email"
              />
            </div>
          </div>
          <div>
            <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
              Subject
            </label>
            <input
              type="text"
              id="subject"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              placeholder="What's this about?"
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
              Message
            </label>
            <textarea
              id="message"
              rows={4}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              placeholder="How can we help you?"
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition-colors duration-300"
          >
            Send Message
          </button>
        </form>
      </div> */}
    </div>
  );
};

export default Support;